import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";
/** @augments {PureComponent<any, any>} */
class Cart extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M7,15.8c-0.1,0.6-0.2,1.2-0.4,1.7c-0.1,0.4-0.2,0.8-0.3,1.2c0,0.1,0,0.2,0.1,0.3c0.3,0.2,0.5,0.5,0.7,0.7
                    C7.3,20,7.4,20,7.6,20c3,0,6.1,0,9.1,0c0.4,0,0.9,0,1.3,0c0.2,0,0.3,0,0.4-0.2c0.5-0.9,1.7-1.3,2.8-1c1,0.4,1.6,1.4,1.4,2.4
                    c-0.2,1-1.2,1.8-2.3,1.7c-1-0.1-1.6-0.5-2-1.3c-0.1-0.2-0.1-0.2-0.3-0.2c-3.4,0-6.8,0-10.3,0c-0.2,0-0.2,0-0.3,0.2
                    C7,22.6,6,23.1,5,23c-1.1-0.2-1.9-1-2-2c-0.1-1,0.6-1.9,1.6-2.2c0.2,0,0.2-0.1,0.3-0.3c0.3-1.3,0.6-2.7,0.8-4c0.1-0.3,0-0.6-0.1-1
                    c-0.4-3-1.1-6-1.8-8.9c0-0.2-0.1-0.2-0.3-0.2c-1.1,0-2.2,0-3.3,0c-0.1,0-0.2,0-0.3,0C0,3.9,0,3.5,0,3c0,0,0,0,0.1,0
                    c1.4,0,2.7,0,4.1,0c0.6,0,1,0.4,1.2,1c0.1,0.6,0.3,1.2,0.4,1.8c0,0,0,0,0,0.1c0.1,0,0.2,0,0.3,0c5.7,0,11.3,0,17,0
                    c0.1,0,0.2,0,0.3,0c0.5,0,0.7,0.3,0.6,0.8c-0.2,1.4-0.4,2.8-0.7,4.1c-0.2,1.4-0.4,2.8-0.7,4.2c-0.1,0.9-0.2,0.9-1.2,0.9
                    c-4.7,0-9.4,0-14.1,0C7.3,15.8,7.2,15.8,7,15.8z"
                />
            </SvgIcon>
        );
    }
}

export default Cart;
